import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import PublicPageBackground from '../../components/PublicPageBackground';
import './Auth.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [emailSent, setEmailSent] = useState(false);


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setEmailSent(true);
      setMessage('Password reset link has been sent to your email. It will expire in 1 hour.');
    } catch (err: any) {
      // Check if it's a network/connection error
      if (!err.response) {
        // Network error - server is not reachable
        setError('Unable to connect to the server. Please check your internet connection and try again.');
        return;
      }
      
      // For security, show same message regardless of whether email exists
      // Only do this for actual server responses (not network errors)
      setEmailSent(true);
      setMessage('Password reset link has been sent to your email. It will expire in 1 hour.');
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <PublicPageBackground>
        <div className="auth-container forgot-password-container">
          <div className="auth-card forgot-password-card">
          <h1 className="forgot-password-title">Check Your Email</h1>
          
          <div className="forgot-password-success-message">
            {message}
          </div>
          
          <div className="forgot-password-info">
            <p>Didn't receive the email? Check your spam folder or try again in a few minutes.</p>
          </div>

          <div className="forgot-password-actions">
            <Link to="/login" className="auth-button">
              Back to Sign In
            </Link>
          </div>
          </div>
        </div>
      </PublicPageBackground>
    );
  }

  return (
    <PublicPageBackground>
      <div className="auth-container">
      <div className="auth-card">
      <div className="auth-header">
          <Link to="/login" className="back-arrow">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
          <div className="auth-title-section">
            <h1>FORGOT PASSWORD</h1>
          </div>
        </div>
        
        <p className="forgot-password-subtitle">Enter your email to reset your password</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              disabled={loading}
              autoComplete="email"
            />
          </div>

          {error && <div className="forgot-password-error">{error}</div>}

          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? 'Sending...' : 'Reset Password'}
          </button>
        </form>
        </div>
      </div>
    </PublicPageBackground>
  );
};

export default ForgotPassword;
